import { useMemoizedFn } from 'ahooks';
import { RangePickerProps } from 'antd/lib/date-picker';
import { ComponentType, useRef } from 'react';

type RangeBlurProps<T extends Pick<RangePickerProps, 'onBlur' | 'onFocus'>> = {
  Component: ComponentType<T>;
} & T;

function RangeBlur<T extends Pick<RangePickerProps, 'onBlur' | 'onFocus'>>(
  props: RangeBlurProps<T>,
) {
  const { onBlur, onFocus, Component, ...otherProps } = props;

  const focusRef = useRef(false);

  const componentProps = {
    onBlur: useMemoizedFn((e) => {
      focusRef.current = false;
      setTimeout(() => {
        if (focusRef.current === false) {
          onBlur?.(e);
        }
      });
    }),
    onFocus: useMemoizedFn((e) => {
      focusRef.current = true;
      onFocus?.(e);
    }),
    ...otherProps,
  } as any;

  return <Component {...componentProps} />;
}

export default RangeBlur;
